import { Button } from '@mui/material'
import React from 'react'

const TableButton = ({
  selectedColor,
  color,
  children,
  clickHandler,
  selected,
}) => {
  return (
    <Button
      color={selected ? selectedColor || 'primary' : color || 'quaternary'}
      size='small'
      sx={{
        elevation: 1,
      }}
      onClick={clickHandler}
    >
      {children}
    </Button>
  )
}

export default TableButton
